export default {"theme":{"dark":false,"themes":{"light":{"primary":"#1a3247","secondary":"#757575","info":"#CFD8DC","accent":"#009688","error":"#ff5370","contrast":"#1a3247","text":"#212121","success":"#009688"}}}}
